// import axiosClient from "./request";
export const API_URL =
"https://api.laundrygo.com.au/v1"
// "https://laundryapp.24livehost.com/v1"     //live
// "https://laundrygoapps.24livehost.com/v1";     dev
// "https://laundrygoappsuat.24livehost.com/v1";    uat
